import HttpService from './http.service';
import { getStep } from './tactonService';

let lastCommitKey = '';
let lastCommitValue = '';

const configuratorService = async step => {
  var response = await HttpService.postByObject(
    'ProductConfigurator/StepConfigurator',
    step
  );
  return response.data;
};

const configuratorServiceStep = async (step, root) => {
  var response = await HttpService.postByObject(
    'ProductConfigurator/StepConfiguratorWithRoot',
    step,
    root
  );
  return response.data;
};

const Commit = async requestData => {
  lastCommitKey = requestData.key;
  lastCommitValue = requestData.value;
  var response = await HttpService.update(
    '/ProductConfigurator/CommitProductMember',
    '',
    requestData
  );
  return response.data;
};

const UnCommit = async requestData => {
  var response = await HttpService.postByObject(
    '/ProductConfigurator/UnCommitProductMember',
    requestData
  );
  return response.data;
};

const batchUncommit = async requestData => {
  let response = await HttpService.postByObject(
    '/ProductConfigurator/BatchUnCommitProductMember/',
    requestData
  );
  return response.data;
};

const batchCommitProductMember = async requestData => {
  if (requestData.isManifoldSegmentStepEdited == false) {
    let response = await configuratorService(requestData);
    if (response) requestData.configState = response?.tactonModel.configState;
  }
  let response = await HttpService.postByObject(
    `/ProductConfigurator/BatchCommitProductMember/`,
    requestData
  );
  return response.data;
};

const start = async requestData => {
  let response = await HttpService.postByObject(
    `/ProductConfigurator/StartConfigurator/`,
    requestData
  );
  return response.data;
};

const initializeFromConfigState = async (
  configModel,
  step,
  configState,
  activeTab
) => {
  var response = await HttpService.postByObject(
    'ProductConfigurator/StepConfigurator',
    {
      ConfigModel: configModel,
      ConfigState: configState,
      Step: step,
      activeTab: activeTab
    }
  );
  return response.data;
};

const InitializeFromConfigStateForManifold = async (
  configModel,
  configState,
  steps
) => {
  var response = await HttpService.postByObject(
    'ProductConfigurator/InitializeFromConfigStateForManifold',
    {
      ConfigModel: configModel,
      ConfigState: configState,
      Steps: steps
    }
  );
  return response.data;
};

const fetchAllManifoldAssemblyStations = async requestModel => {
  let response;
  await HttpService.postByObject(
    `/ProductConfigurator/GetAllManifoldAssemblyStations/`,
    requestModel
  )
    .then(res => (response = res.data))
    .catch(error => console.log(error));
  return response;
};

const commitAssemblyManifold = async requestData => {
  lastCommitKey = requestData.key;
  lastCommitValue = requestData.value;
  if (!requestData.isManifoldSegmentStepEdited) {
    let response = await configuratorService(requestData);
    if (response) requestData.configState = response?.tactonModel.configState;
  }

  let response = await Commit(requestData);

  return response;
};

const unCommitAssemblyManifold = async requestData => {
  if (!requestData.isManifoldSegmentStepEdited) {
    let response = await configuratorService(requestData);
    if (response) requestData.configState = response?.tactonModel.configState;
  }

  let response = await UnCommit(requestData);

  return response;
};

const configureFromConfigState = async (
  uniqueIdentifierModel,
  sessionData,
  startData
) => {
  let requestModel = {
    divisionId: sessionData?.manufacturingLocation,
    configState: uniqueIdentifierModel.configState,
    step: getStep(startData).name,
    configModel: sessionData?.configModel
  };

  let response;
  await HttpService.postByObject(
    `/ProductConfigurator/ConfigureFromConfigState/`,
    requestModel
  )
    .then(res => (response = res.data))
    .catch(error => console.log(error));
  return response;
};

const configureFromBom = async (bomModel, sessionData, startData) => {
  var requestModel = {
    step: startData.isDynamicStackableProduct ? 'product_selection' : '',
    configModel: sessionData.configModel,
    configState: startData.configState,
    isPartSearchforDynamicStack: false,
    divisionId: sessionData.manufacturingLocation,
    guid: bomModel.guid,
    countryCode: bomModel.countryCode,
    countryId: bomModel.countryId,
    language: bomModel.language,
    userId: bomModel.userId,
    manufacturingDivision: bomModel.manufacturingDivision,
    configCodeComplete: bomModel.configCodeComplete,
    configCodeLegacy: bomModel.configCodeLegacy,
    configInput: bomModel.configInput,
    configPayload: bomModel.configPayload,
    selections: bomModel.selections,
    bomPayload: bomModel.bomPayload,
    productId: bomModel.productId,
    ERP_Code: bomModel.ERP_Code,
    sessionId: bomModel.sessionId,
    manufacturingLocation: bomModel.manufacturingLocation
  };

  var url = '';
  if (startData.isNormalProduct) {
    if (startData.isDynamicStackableProduct)
      url = '/ProductConfigurator/ConfigureFromBomDynamicStack/';
    else url = '/ProductConfigurator/ConfigureFromBom/';
  } else url = '/ProductConfigurator/ConfigureFromBomForStackables/';

  let response;
  await HttpService.postByObject(url, requestModel)
    .then(res => (response = res.data))
    .catch(error => console.log(error));
  return response;
};

const Accept = async requestData => {
  requestData.key = lastCommitKey;
  requestData.value = lastCommitValue;
  var response = await HttpService.postByObject(
    'ProductConfigurator/Accept',
    requestData
  );
  return response.data;
};

export {
  configuratorService,
  configuratorServiceStep,
  Commit,
  batchUncommit,
  batchCommitProductMember,
  start,
  initializeFromConfigState,
  fetchAllManifoldAssemblyStations,
  commitAssemblyManifold,
  unCommitAssemblyManifold,
  InitializeFromConfigStateForManifold,
  configureFromConfigState,
  configureFromBom,
  Accept,
  UnCommit
};
